<template>
    <div>
        <div class="card mb-3">

            <div class="card-header text-muted">
                Custom Fields
            </div>

            <div class="card-body">
                <template v-for="field in fields">

                    <h4 v-if="field.name == 'Heading'">{{ field.label }}</h4>

                    <div v-else-if="field.parent_field_id == null || shouldRender(field.id, field.parent_field_id)" class="form-group row">
                        <label :class="`${labelSize} col-form-label text-sm-right`">
                            <span :class="{'text-danger': errors['customFields.'+field.id]}">
                                <template v-if="field.label">
                                    {{ field.label }}
                                    <i v-if="field.help_text" class="fa fa-question-circle" :title="field.help_text"></i>:
                                    <i v-if="field.is_required && (customFields[field.id] === null || customFields[field.id] === undefined) || customFields[field.id] === '' || (Array.isArray(customFields[field.id]) && customFields[field.id].length === 0)" class="fa fa-asterisk text-danger"></i>
                                </template>
                            </span>
                        </label>
                        <div :class="fieldSize">
                            <template v-if="field.name == 'Text'">
                                <b-form-input v-model="customFields[field.id]" :placeholder="field.placeholder ? field.placeholder : 'Enter Text Value'" :class="{'is-invalid': errors['customFields.'+field.id]}"></b-form-input>
                            </template>
                            <template v-if="field.name == 'Dropdown'">
                                <b-form-select v-model="customFields[field.id]" :value="field.allow_multiple ? [] : null" :options="field.options" :multiple="field.allow_multiple" :class="{'is-invalid': errors['customFields.'+field.id]}">
                                    <template v-slot:first v-if="!field.allow_multiple">
                                        <option :value="null">
                                            <template v-if="field.placeholder">{{ field.placeholder }}</template>
                                            <template v-else>-- Select an Option --</template>
                                        </option>
                                    </template>
                                </b-form-select>
                                <div v-if="field.allow_multiple">Hold "Ctrl" and click options to select multiple.</div>
                            </template>
                            <template v-if="field.name == 'Radio'">
                                <b-form-radio-group v-model="customFields[field.id]" :options="field.options" plain :stacked="field.display_vertical" :class="{'is-invalid': errors['customFields.'+field.id]}"></b-form-radio-group>
                            </template>
                            <template v-if="field.name == 'Checkbox'">
                                <b-form-checkbox-group v-model="customFields[field.id]" :options="field.options" plain :stacked="field.display_vertical" :class="{'is-invalid': errors['customFields.'+field.id]}"></b-form-checkbox-group>
                            </template>
                            <template v-if="field.name == 'Textarea'">
                                <template v-if="field.enable_rich_text">
                                    <vue-editor v-model="customFields[field.id]" :placeholder="field.placeholder ? field.placeholder : 'Enter Textarea Value'" rows="4" :editor-toolbar="this.$root.customVueEditorToolbar"></vue-editor>
                                </template>
                                <template v-else>
                                    <b-form-textarea v-model="customFields[field.id]" :placeholder="field.placeholder ? field.placeholder : 'Enter Textarea Value'" rows="4" :class="{'is-invalid': errors['customFields.'+field.id]}"></b-form-textarea>
                                </template>
                            </template>
                            <template v-if="field.name == 'Date'">
                                <date-picker v-model="customFields[field.id]" :config="{format: field.format, useCurrent: false}" :placeholder="field.placeholder ? field.placeholder : 'Enter Date Value'" :class="{'is-invalid': errors['customFields.'+field.id]}"></date-picker>
                            </template>

                            <template v-if="field.name == 'Time'">
                                <date-picker v-model="customFields[field.id]" :config="{format: 'h:mm a', useCurrent: false}" :placeholder="field.placeholder ? field.placeholder : 'Enter Time Value'" :class="{'is-invalid': errors['customFields.'+field.id]}"></date-picker>
                            </template>

                            <template v-if="field.name == 'Email'">
                                <input v-model="customFields[field.id]" type="email" :placeholder="field.placeholder ? field.placeholder : 'Enter Email Value'" :class="{'form-control': true, 'is-invalid': errors['customFields.'+field.id]}" />
                            </template>

                            <template v-if="field.name == 'Phone'">
                                <input v-model="customFields[field.id]" type="tel" class="form-control" pattern="[0-9]{3}-[0-9]{3}-[0-9]{4}" :placeholder="field.placeholder ? field.placeholder : 'Enter Phone Number in format: XXX-XXX-XXXX'" :class="{'is-invalid': errors['customFields.'+field.id]}">
                            </template>

                            <template v-if="field.name == 'Number'">
                                <input v-model="customFields[field.id]" type="number" class="form-control" :placeholder="field.placeholder ? field.placeholder : 'Enter Number Value'"  :step="field.step ? field.step : 1" :min="field.min" :max="field.max" :class="{'is-invalid': errors['customFields.'+field.id]}" />
                            </template>

                            <template v-if="field.name == 'Paragraph'">
                                <div class="my-2" :class="field.color ? 'alert alert-'+field.color : 't'">
                                    {{ field.text }}
                                </div>
                            </template>

                            <span v-if="errors['customFields.'+field.id]" class="text-danger">
                                <span v-for="(err, key) in errors['customFields.'+field.id]">{{ err }}</span>
                            </span>
                        </div>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            fields: {
                type: Array,
                required: true,
            },

            blockType: {
                type: String,
                default: 'card',
            },

            initialValues: {
                type: Object,
                //default: function () { return {} },
            },

            errors: {
                type: Object,
                default: function () { return {} },
            },

            labelSize: {
                type: String,
                default: 'col-lg-2 col-md-3 col-sm-4'
            },

            fieldSize: {
                type: String,
                default: 'col-lg-8 col-md-8 col-sm-8',
            },
        },

        data: function() {
            return {
                customFields: {},
            }
        },

        computed: {
            listString() {
              return JSON.stringify(this.customFields, null, 2);
            },
        },

        watch: {
            //Emit the Payload
            customFields(newValue, oldValue){
                //console.log(newValue);
                //Emit
                this.$emit('customFieldsChanged', newValue);
            },
        },

        methods: {
            //Should Render
            shouldRender(fieldId, parentFieldId){
                //If Parent is NULL, return true
                if(!parentFieldId)
                {
                    return true;
                }

                //Debugging
                //console.log(this.customFields);

                //Loop through the fields
                for(let i = 0; i < this.fields.length; i++)
                {
                    //Check the ID
                    if(fieldId == this.fields[i].id)
                    {
                        //Log it
                        //console.log(this.sections[i].fields[j]);
                        //console.log(this.customFields);

                        //Check if the value is an array
                        if(Array.isArray(this.customFields[parentFieldId]) && this.customFields[parentFieldId].indexOf(this.fields[i].parent_field_value) >= 0)
                        {
                            return true;
                        }
                        else if(this.customFields[parentFieldId] == this.fields[i].parent_field_value)
                        {
                            return true;
                        }
                    }
                }

                //Unset the value
                if(this.customFields[fieldId])
                {
                    delete this.customFields[fieldId];
                }

                //Default
                return false;
            }
        },

        mounted() {
            //Set
            if(this.initialValues)
            {
                this.customFields = this.initialValues;
            }
        }
    }
</script>